import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { ModalComponent } from '../modal/modal.component';
import { NotificationService } from '../../services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-preview',
  templateUrl: './upload-preview.component.html',
  styleUrls: ['./upload-preview.component.scss'],
})
export class UploadPreviewComponent {
  @Input({ required: true }) previewTitle: string = '';

  private modalRef: MatDialogRef<ModalComponent>;

  private backendUrl = environment.url;

  public previewImage;

  public previewUrl: string = '';

  public previewImageName: string = '';

  @Output() onDelete = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private _notification: NotificationService,
    private _transloco: TranslocoService
  ) {}

  /**  Set image preview from selected file
   * @param file Selected file
   */
  public setPreviewImageFromFile(file: File) {
    this.previewImageName = file.name;
    let reader = new FileReader();

    reader.onload = (event: any) => {
      this.previewUrl = event.target.result;
    };
    reader.readAsDataURL(file);
  }

  /** Set image preview with url from db
   * @param url Image url in db
   */
  public async setPreviewImageFromUrl(url: string) {
    this.previewUrl = this.backendUrl + url;
    this.previewImageName = this.previewUrl?.slice(
      this.previewUrl?.lastIndexOf('/') + 1
    );

    await fetch(this.previewUrl)
      .then((r) => r.blob())
      .then(
        (blobFile) =>
          (this.previewImage = new File([blobFile], this.previewImageName))
      );
  }

  /** Open confirm delete modal for preview/image removal */
  public opetConfirmDeleteModal() {
    this.modalRef = this.dialog.open(ModalComponent, {
      data: {
        heading: 'coupons.deleteImageModalHeading',
        okButtonText: 'global.delete',
        text: ['global.confirmDelete'],
        textHighlightBottom: 'global.irreversibleAction',
        showCancelBtn: true,
      },
    });

    this.modalRef.componentInstance.onSave.subscribe(() => {
      this._notification.success(
        this._transloco.translate('coupons.deleteImageSuccess')
      );
      this.resetPreview();
      this.onDelete.emit();
    });
  }

  /** Reset preview values */
  private resetPreview() {
    this.previewUrl = '';
    this.previewImage = null;
    this.previewImageName = null;
  }
}
